export default __webpack_public_path__ + "static/media/shareLesson.cb1bace8.svg";